import config from '../config';

export default {
	init() {
		window.ga('create', config.google_analytics, 'auto');
	},

	sendPageView(page) {
		window.ga('send', 'pageview', page);
	},

	sendEvent(page, action, label, value = 1) {
		window.ga('send', 'event', page, action, label, value);
	}
};



// WEBPACK FOOTER //
// ./src/helpers/ga.js